import React, { useEffect, useState } from 'react'

import { TextField, Stack, Box } from '@mui/material'
import { deleteUserCloseAccount, getSecurityOptions } from '@/api/user'
import Modal2 from '@/components/Modal2'
import { Text } from './common'
import { Controller, useForm } from 'react-hook-form'
import { useRequest } from 'ahooks'
import SecurityVerifyPanel from './SecurityVerifyPanel'

interface WriteOffModalProps {
  open: boolean
  verified: boolean
  onCancel: () => void
  currentPhone?: string
  currentMail?: string
}

const WriteOffModal: React.FC<WriteOffModalProps> = ({ open, onCancel, verified, currentPhone, currentMail }) => {
  const [verifyType, setVerifyType] = useState('')
  const {
    control,
    formState: { errors },
    handleSubmit,
    reset,
    watch,
    trigger,
    setValue,
  } = useForm({
    defaultValues: {
      code: '',
      verify_code: '',
      verify_password: '',
      verify_state: '',
    },
  })

  const { data: securityOptions, runAsync: loadSecurityOptions } = useRequest(() => getSecurityOptions('close_account'), {
    manual: true,
  })

  useEffect(() => {
    if (open) {
      loadSecurityOptions().then((res) => {
        setVerifyType(res?.recommended_verify_type || res?.available_verify_types?.[0] || '')
      })
    } else {
      reset()
      setVerifyType('')
    }
  }, [open, loadSecurityOptions, reset])

  const onSubmit = handleSubmit((data) => {
    deleteUserCloseAccount({
      verify_type: verifyType as 'phone' | 'email' | 'password' | 'wechat',
      verify_code: data.verify_code,
      verify_password: data.verify_password,
      verify_state: data.verify_state,
      confirmation_text: data.code,
    }).then(() => {
      onCancel()
      window.location.href = '/login'
    })
  })

  return (
    <Modal2
      title='提示'
      width={625}
      okText='注销'
      okButtonProps={{ color: 'error' }}
      open={open}
      onCancel={onCancel}
      onOk={onSubmit}
    >
      <Text sx={{ fontSize: 14 }}>确定注销当前账号吗？</Text>
      <Text sx={{ fontSize: 14, color: 'error.main', mt: 2, mb: 3 }}>
        1. 注销后，此账号的所有数据都将被删除且不可逆，请谨慎操作！
        {verified && <Box sx={{ mt: 1 }}>2. 一旦注销账户，你需要等待7天后才能重新进行实名认证</Box>}
      </Text>
      <Stack gap={3}>
        <SecurityVerifyPanel
          scene='close_account'
          open={open}
          options={securityOptions}
          verifyType={verifyType}
          onVerifyTypeChange={setVerifyType}
          control={control}
          errors={errors}
          trigger={trigger}
          setValue={setValue}
          watch={watch}
          currentPhone={currentPhone}
          currentMail={currentMail}
        />
        <Stack direction='row' alignItems='center' sx={{ fontSize: 14, mt: 1, mb: 1, color: 'rgba(0,0,0,0.5)' }}>
          输入 “<Text sx={{ color: '#000', fontWeight: 500 }}>确认注销</Text>” 以确认操作
        </Stack>
        <Controller
          rules={{
            required: '请输入确认注销',
            validate: (value) => value === '确认注销' || '请输入确认注销',
          }}
          name='code'
          control={control}
          render={({ field }) => (
            <TextField
              required
              placeholder='请输入'
              {...field}
              variant='outlined'
              fullWidth
              error={Boolean(errors.code)}
              helperText={errors.code?.message as string}
              size='small'
              autoComplete='off'
            />
          )}
        />
      </Stack>
    </Modal2>
  )
}

export default WriteOffModal
